import { StateContext } from "@ngxs/store";

export class CustomState<T> {
    public obtenerNuevoState(ctx: StateContext<T>): T {
        const stateAnterior = ctx.getState();
        return { ...stateAnterior };
    }
}
